export default `
  mutation convertInvitesToTeamMembers {
    convertInvitesToTeamMembers {
      id
      projectId
      userId
      createdAt
    }
  }
`
